import React, { useState, useRef, useEffect } from 'react';
import './App.css';

function DroneImagefly() {
  const [fly, setFly] = useState(false);
  const droneImage = process.env.PUBLIC_URL + "/dronehehe.png";

  function handleClick() {
    // toggle fly state to trigger animation
    setFly(prev => !prev);
  }

  return (
    <div className="drone-fly-container">
      <button className="toggle" onClick={handleClick}>
        Wanna see a drone?
      </button>
      <img
        src={droneImage}
        alt="Flying Drone"
        className={`drone-fly-img ${fly ? 'fly' : ''}`}
        style={{
          width: '220px',
          height: '120px',
        }}
      />
    </div>
  );
}

/* ==== MeetTeamPopup component (draggable, plays sound on open) ==== */
function MeetTeamPopup() {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const [pos, setPos] = useState({ x: 100, y: 80 });
  const dragging = useRef(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  const audioRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio(process.env.PUBLIC_URL + '/open.wav');
    audioRef.current.volume = 0.6;
  }, []);

  useEffect(() => {
    function onMove(e) {
      if (!dragging.current) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      setPos({ x: clientX - dragOffset.current.x, y: clientY - dragOffset.current.y });
    }
    function onUp() { dragging.current = false; }
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
    };
  }, []);

  function openPopup() {
    const w = Math.min(1000, window.innerWidth - 40);
    const x = Math.max(20, (window.innerWidth - w) / 2);
    const y = 80;
    setPos({ x, y });
    setClosing(false);
    setOpen(true);
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    }
  }

  function closePopup() {
    // trigger exit animation then unmount
    setClosing(true);
    // match CSS .popup-exit animation duration (450ms) + small buffer
    setTimeout(() => {
      setOpen(false);
      setClosing(false);
    }, 520);
  }

  function startDrag(e) {
    e.preventDefault();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    dragging.current = true;
    dragOffset.current = { x: clientX - pos.x, y: clientY - pos.y };
  }

  const members = [
    { name: 'Anil Deane', role: 'Team Mentor', img: '/AnilDeane-SSP_3466-web.jpg' },
    { name: 'Sarah Weiss', role: 'Team Librarian', img: '/Profile_Pic1.jpg' },
    { name: 'Siloe Selebangue', role: 'Aerospace Engineering', img: '/IMG_9205 - Siloe Selebangue (1).jpeg' },
    { name: 'Michael King', role: 'Aerospace Engineering', img: '/Resized_20240524_121842_1719191037819 - Michael King (1).jpeg' },
    { name: 'Hannah Alper', role: 'Electrical Engineering', img: '/hannah_alper_headshot - Hannah Alper.jpeg' },
    { name: 'Kiyan Govender', role: 'Aerospace Engineering', img: '/IMG_3609 - SoloSkills.jpeg' },
    { name: 'Josh McDerment', role: 'Aerospace Engineering', img: '/17528811596184244253163488230211 - Josh McDerment.jpg' },
    { name: 'Larry Djatang-Tankeu', role: 'Electrical Engineering', img: '/Screenshot_20250721-073203_Instagram - Larry Djatang Tankeu.jpg' },
    { name: 'Kevin Nguyen', role: 'Computer Engineering', img: '/Screenshot 2025-07-31 172933 - Copy.png' },
    { name: 'Sam Biddle', role: 'Mechanical Engineering', img: '/IMG_3532.JPG' },
    { name: 'Ali Shaalan', role: 'Mathematics', img: '/IMG_20250815_211738 - Ali S.jpg' },
    { name: 'Muhammad Rahman', role: 'Physics', img: '/muh.jpg' },
  ];

  return (
    <>
      <button className="meet-the-team-button" onClick={openPopup} aria-haspopup="dialog">
        <img src={process.env.PUBLIC_URL + "/group-chat.png"} alt="Meet" className="team-icon" style={{ verticalAlign: 'middle' }} />
        Meet the Team
      </button>

      {open && (
        <>
          <div
            className={`popup-overlay ${closing ? 'overlay-exit' : ''}`}
            onClick={closePopup}
            style={{ position: 'fixed', inset: 0, zIndex: 1010 }}
          />

          <div
            ref={popupRef}
            role="dialog"
            aria-label="Meet the Team"
            className={`popup-content meet-team-popup ${closing ? 'popup-exit' : 'popup-enter'}`}
            style={{
              position: 'fixed',
              left: pos.x,
              top: pos.y,
              width: Math.min(1000, window.innerWidth - 80),
              maxWidth: '92vw',
              maxHeight: '88vh',
              overflow: 'auto',
              zIndex: 1011,
              borderRadius: 12,
              padding: 24,
              background: '#e9e9e9',
              color: '#111',
              boxShadow: '0 24px 60px rgba(2,16,40,0.45)',
            }}
          >
            <div
              className="meet-team-header"
              onMouseDown={startDrag}
              onTouchStart={startDrag}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 12, cursor: 'grab', userSelect: 'none' }}
            >
              <strong style={{ fontSize: 18 }}>Meet the Team</strong>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={closePopup} aria-label="Close" style={{ background: 'transparent', border: 'none', fontSize: 18, cursor: 'pointer', padding: 6 }}>✕</button>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: 16,
                alignItems: 'start',
              }}
            >
              {/* Top row: Mentor + Librarian (their own row) */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                  gap: 14,
                }}
              >
                {members.slice(0, 2).map((m) => (
                  <div
                    key={m.name}
                    style={{
                      background: 'rgba(255,255,255,0.95)',
                      borderRadius: 10,
                      padding: 16,
                      textAlign: 'center',
                      color: '#0b2233',
                      minHeight: 140,
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + m.img}
                      alt={m.name}
                      style={{
                        width: 120,
                        height: 120,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        marginBottom: 8,
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    />
                    <div style={{ fontWeight: 800 }}>{m.name}</div>
                    <div style={{ fontSize: 14, color: '#234' }}>{m.role}</div>
                    {m.bio && <div style={{ marginTop: 8, fontSize: 13 }}>{m.bio}</div>}
                  </div>
                ))}
              </div>

              {/* Remaining members */}
              <div
                className="team-grid-rows"
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                  gap: 14,
                  alignItems: 'start',
                }}
              >
                {members.slice(2).map((m) => (
                  <div
                    key={m.name}
                    style={{
                      background: 'rgba(255,255,255,0.9)',
                      borderRadius: 10,
                      padding: 10,
                      textAlign: 'center',
                      color: '#0b2233',
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + m.img}
                      alt={m.name}
                      style={{
                        width: 96,
                        height: 96,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        marginBottom: 8,
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    />
                    <div style={{ fontWeight: 700 }}>{m.name}</div>
                    <div style={{ fontSize: 13, color: '#234' }}>{m.role}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

function App() {
  // add theme state (dark by default)
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    // apply/remove dark theme class on the root element
    if (theme === 'dark') {
      document.documentElement.classList.add('theme-dark');
    } else {
      document.documentElement.classList.remove('theme-dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <div className="App">
      <div className="animated-bg">
        <div className="wave wave1"></div>
        <div className="wave wave2"></div>
        <div className="wave wave3"></div>
      </div>

      <div className="Team-SOAR">
        <header className="App-header" />
        <h1 className="slide-in-bck-top">Team SOAR</h1>
        <p>Sustainable Operations for Aerial Robotics</p>

        {/* Theme toggle (simple) */}
        <div style={{ marginTop: 10 }}>
          <button
            className={`toggle-theme ${theme === 'dark' ? 'dark' : 'light'}`}
            onClick={() => setTheme(t => (t === 'dark' ? 'light' : 'dark'))}
            aria-pressed={theme === 'dark'}
            title="Toggle light / dark"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
          >
            {/* Sun SVG */}
            <svg className="theme-icon sun-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="18" height="18">
              <circle cx="12" cy="12" r="4" fill="currentColor"/>
              <g stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1.5" x2="12" y2="3.5"/>
                <line x1="12" y1="20.5" x2="12" y2="22.5"/>
                <line x1="4.2" y1="4.2" x2="5.6" y2="5.6"/>
                <line x1="18.4" y1="18.4" x2="19.8" y2="19.8"/>
                <line x1="1.5" y1="12" x2="3.5" y2="12"/>
                <line x1="20.5" y1="12" x2="22.5" y2="12"/>
                <line x1="4.2" y1="19.8" x2="5.6" y2="18.4"/>
                <line x1="18.4" y1="5.6" x2="19.8" y2="4.2"/>
              </g>
            </svg>

            {/* Moon SVG */}
            <svg className="theme-icon moon-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="18" height="18">
              <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill="currentColor"/>
            </svg>

            <span style={{ fontSize: 13 }}>{theme === 'dark' ? 'Dark Mode' : 'Light Mode'}</span>
          </button>
        </div>
      </div>

      <div className="App-footer">
        <img
          className="Drone-Img"
          src="https://wallpapercave.com/wp/wp1896544.jpg"
          alt="Team SOAR Logo"
        />
      </div>

      <div className="main-information">
        <h2 className="mission-statement">Welcome to Team SOAR!</h2>
        <div className="scroll-container">
          <p>
            We are an undergraduate research team at the University of Maryland, College Park.
            We hope to improve the efficiency of drones by utilizing wind updrafts and computer
            vision to greatly extend their flight time.
          </p>
        </div>
      </div>

      <h2 className="project-scope">Project Scope</h2>
      <div className="scroll-container">
        <p>
          Our project aims to develop a drone that can autonomously detect and utilize wind
          updrafts to extend its flight time. We will achieve this by integrating computer
          vision algorithms to identify updrafts and control systems to optimize flight paths.
        </p>
        <p>
          We will also conduct extensive testing and validation to ensure the reliability and
          efficiency of our drone system. Our goal is to create a prototype that can demonstrate
          the feasibility of using wind updrafts for sustainable drone operations.
        </p>
      </div>

      <div className="pop-up">
        <div className="button-container">
          {/* add the Meet the Team button/popup */}
          <MeetTeamPopup />

          <button
            className="timeline-page-html-button"
            onClick={() => window.open(process.env.PUBLIC_URL + "/Members.html", "_blank")}
          >
            <img
              src={process.env.PUBLIC_URL + "/timeline.png"}
              alt="Timeline Icon"
              className="timeline-icon"
            />
            Timeline
          </button>

          <button
            className="papers-page-html-button"
            onClick={() => window.open(process.env.PUBLIC_URL + "/papers.html", "_blank")}
          >
            <img
              src={process.env.PUBLIC_URL + "/research.png"}
              alt="Papers Icon"
              className="papers-icon"
            />
            Papers and Research
          </button>

          <button
            className="App-button"
            onClick={() => window.open("https://github.com/kevinng5213/soarumd", "_blank")}
          >
            <img
              src={process.env.PUBLIC_URL + "/github.png"}
              alt="GitHub Logo"
              className="github-logo"
            />
            Visit Our GitHub
          </button>
        </div>
      </div>

      <div className="see-a-drone">
        <DroneImagefly />
      </div>

      <div className="footer">
        <div className="line" />
        <p className="credits">Website made by Team SOAR at UMD 🐢</p>
        <p className="credits">Contact: knguye34@umd.edu</p>

        <div className="buttons">
          <button
            className="umd-logo-button"
            onClick={() => window.open("http://www.honors.umd.edu")}
            aria-label="UMD Honors College"
          >
            <img src={process.env.PUBLIC_URL + "/honors-college.png"} alt="UMD Logo" />
          </button>

          <button
            className="gems-logo-button"
            onClick={() => window.open("http://www.gemstone.umd.edu")}
            aria-label="Gems Program"
          >
            <img src={process.env.PUBLIC_URL + "/g_honors_college SMALL_2.png"} alt="Gems Logo" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
